/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const hanger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 7.667a7.175 7.175 0 0 1 6.952 4.682 1.033 1.033 0 0 1-.133.902.955.955 0 0 1-.785.416H1.966a.954.954 0 0 1-.783-.416 1.029 1.029 0 0 1-.133-.902A7.175 7.175 0 0 1 8 7.667Zm0 0V5a1.5 1.5 0 1 1 1.5-1.5"
    />
  </svg>
)
export default hanger
